import crudActionCreators from './crudActionCreators';

const cac = new crudActionCreators('todo_list', '/admin/todo_lists');

export const loadAction = cac.loadAction;
export const addAction = cac.addAction;
export const deleteAction = cac.deleteAction;
export const putAction = cac.putAction;
export const updateAction = cac.updateAction;
